import Locales from '../locales/index';

let knowledgeType = [
    { id: 1, key: 'oneToOne', name: () => Locales.current.enums.knowledgeType.oneToOne }
];

export default {
    knowledgeType,
};